import type { AnimationI, TickerI } from "tweenly"
import gsap from "gsap"
import { applyJoinedScrollTexts } from "tweenly"
import { initSubTimelineTween } from "../tween.helpers"
import { BaseTicker } from "./BaseTicker"
import { ScrollCtx } from "./types"

export class ScrollUpDownTicker extends BaseTicker {
    private readonly maskObject: TickerI
    private readonly animationGroup: AnimationI[]
    private readonly textListNode: HTMLElement | null

    constructor(args: ScrollCtx) {
        super(args.timeline, args.objectId, args.joinedTexts, args.childTexts, args.assets)
        this.maskObject = args.maskObject
        this.animationGroup = args.animationGroup
        this.textListNode = args.textListNode
    }

    //needed for prevent glitching
    private killTweens() {
        gsap.killTweensOf(`#${this.objectId}`)
        for (const childId of this.maskObject.childIds) {
            gsap.killTweensOf(`#${childId}`)
        }
    }

    protected intro() {
        this.killTweens()
        this.timeline.clear()

        for (const animation of this.animationGroup) {
            if (animation.subTimelineType?.startsWith("scrollUpDown")) {
                initSubTimelineTween(animation, animation.objectId, this.timeline)
            }
        }

        for (const childId of this.maskObject.childIds) {
            gsap.set(`#${childId}`, { y: "0%" })
        }

        this.timeline.set(`#${this.objectId}`, {
            x: "0px",
            onComplete: () => this.repeat(),
        })
    }

    private repeat() {
        this.killTweens()
        this.timeline.clear()

        for (const animation of this.animationGroup) {
            if (animation.subTimelineType?.startsWith("scrollUpDown")) {
                initSubTimelineTween(animation, animation.objectId, this.timeline)
            }
        }

        for (const childId of this.maskObject.childIds) {
            gsap.set(`#${childId}`, { y: "0%" })
        }

        this.timeline.set(`#${this.objectId}`, {
            x: "0px",
            onComplete: () => this.handleRepeat(() => this.repeat()),
        })
    }

    protected outro(newTexts?: string) {
        this.killTweens()
        this.timeline.clear()

        for (const animation of this.animationGroup) {
            if (animation.subTimelineType?.startsWith("scrollUpDown")) {
                initSubTimelineTween(animation, animation.objectId, this.timeline)
            }
        }

        for (const childId of this.maskObject.childIds) {
            gsap.set(`#${childId}`, { y: "0%" })
        }

        this.timeline.set(`#${this.objectId}`, {
            x: "0px",
            onComplete: () => {
                if (newTexts) {
                    this.currentJoinedTexts = newTexts
                    applyJoinedScrollTexts(this.textListNode, this.maskObject.childIds, newTexts)
                }
                this.intro()
            },
        })
    }
}
